import { Injectable } from '@angular/core';
import { ClientAuthErrorCodes } from '@models';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ErrorMapperService {
    public auth: Observable<any>;
    public authProperties =
        Object.keys(ClientAuthErrorCodes)
            .filter(key => isNaN(Number(key)));

    constructor(translateService: TranslateService) {
        const authPropertyKeys = this.authProperties.map(
            prop => `AuthErrorCode_${prop}`,
        );

        this.auth = translateService
            .stream(authPropertyKeys)
            .pipe(
                map(translations => {
                    const mapped: Record<string, string> = {};

                    this.authProperties.forEach(key => {
                        mapped[key] = translations[`AuthErrorCode_${key}`];
                    });

                    return mapped;
                }),
            );
    }
}
